(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 98160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_register; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/LanguageSwitch/index.tsx + 1 modules
var LanguageSwitch = __webpack_require__(92699);
// EXTERNAL MODULE: ./src/assets/logoText.svg
var logoText = __webpack_require__(17649);
// EXTERNAL MODULE: ./src/pages/register/style/index.module.less
var index_module = __webpack_require__(50859);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/pages/login/banner.tsx
var banner = __webpack_require__(67426);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconWechat/index.js
var IconWechat = __webpack_require__(81025);
// EXTERNAL MODULE: ./src/assets/google.svg
var google = __webpack_require__(63144);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Spin/index.js + 1 modules
var Spin = __webpack_require__(62258);
// EXTERNAL MODULE: ./src/pages/login/login-btn.tsx
var login_btn = __webpack_require__(88848);
// EXTERNAL MODULE: ./src/pages/login/wechat-login.tsx
var wechat_login = __webpack_require__(19959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Form/index.js + 15 modules
var Form = __webpack_require__(65976);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Message/index.js + 1 modules
var Message = __webpack_require__(80507);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./src/api/login.ts
var login = __webpack_require__(50033);
// EXTERNAL MODULE: ./src/hooks/useAfterOnboarding.ts
var useAfterOnboarding = __webpack_require__(30473);
// EXTERNAL MODULE: ./src/components/CustomInput/index.tsx
var CustomInput = __webpack_require__(1926);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(1925);
// EXTERNAL MODULE: ./src/utils/checkLogin.tsx
var checkLogin = __webpack_require__(23199);
// EXTERNAL MODULE: ./src/hooks/useBdVid.ts
var useBdVid = __webpack_require__(63128);
// EXTERNAL MODULE: ./src/utils/gtagEvent.ts
var gtagEvent = __webpack_require__(73491);
// EXTERNAL MODULE: ./src/api/common.ts
var common = __webpack_require__(74169);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(42586);
// EXTERNAL MODULE: ./src/utils/useLang.ts
var useLang = __webpack_require__(877);
;// CONCATENATED MODULE: ./src/hooks/useEmailCaptcha.ts






const useEmailCaptcha = (form, onSuccess) => {
  const t = (0,useLocale/* default */.Z)();
  const lang = (0,useLang/* default */.Z)();
  const isChinese = lang === 'zh-CN';

  const handleCaptchaCallback = async res => {
    if (res.ret === 0) {
      var _resData$data;

      const {
        email
      } = form.getFields();
      const resData = await (0,common/* postTencentCaptchaApi */.Yf)({
        ticket: res.ticket,
        rand_str: res.randstr,
        email
      });
      (resData === null || resData === void 0 ? void 0 : (_resData$data = resData.data) === null || _resData$data === void 0 ? void 0 : _resData$data.code) === constants/* SUCCESS_CODE */.Gh && onSuccess();
    }
  };

  const handleLoadError = () => {
    const appid = constants/* TENCENT_APPID */.gw; // 生成容灾票据或自行做其它处理

    const ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
    handleCaptchaCallback({
      ret: 0,
      randstr: '@' + Math.random().toString(36).substr(2),
      ticket: ticket,
      errorCode: 1001,
      errorMessage: 'jsload_error'
    });
  };

  async function onCaptchaShow() {
    try {
      const {
        email
      } = form.getFields();

      if (!email || !utils/* emailReg.test */.m0.test(email)) {
        return Message/* default.error */.Z.error(t['login.form.email.errMsg']);
      } // 生成一个验证码对象
      // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
      // callback：定义的回调函数


      const captcha = new TencentCaptcha(constants/* TENCENT_APPID */.gw, handleCaptchaCallback, {
        userLanguage: isChinese ? 'zh-cn' : 'en'
      }); // 调用方法，显示验证码

      captcha.show();
    } catch (error) {
      console.log('loadErrorCallback回调函数:', error); // 加载异常，调用验证码js加载错误处理函数

      handleLoadError();
    }
  }

  return {
    handleCaptchaCallback,
    handleLoadError,
    onCaptchaShow
  };
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/register/form.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















const initialValues = {
  email: '',
  password: '',
  invite_code: ''
};
function LoginForm(props) {
  const {
    sessionFlag,
    inviteCode,
    step,
    btns,
    email,
    isEffective,
    platform,
    onChangeForm
  } = props || {};
  const promotionInfo = (0,useBdVid/* getPromotionInfo */.yG)();
  const [form] = Form/* default.useForm */.Z.useForm();
  const {
    0: loading,
    1: setLoading
  } = (0,react.useState)(false);
  const t = (0,useLocale/* default */.Z)();
  const {
    afterRegisterSuccess
  } = (0,useAfterOnboarding/* default */.Z)({
    rememberPassword: false
  });

  const handleSignUpRes = (params, signUpRes) => {
    signUpRes.then(res => {
      const {
        code
      } = (res === null || res === void 0 ? void 0 : res.data) || {};

      if (code === 0) {
        (0,checkLogin/* clearInviteCode */.E$)();
        Message/* default.success */.Z.success(t['register.form.result.successMsg']); // 增加百度统计，注册转化成功

        (0,utils/* baiduRegisterEvent */.Rk)();
        (0,gtagEvent/* gtagRegisterEvent */.IQ)();
        afterRegisterSuccess(params, res === null || res === void 0 ? void 0 : res.data);
      } else {
        console.log(code);
      }
    }).catch(err => {
      var _err$response, _err$response$data;

      console.log('err', err === null || err === void 0 ? void 0 : err.response); // 设置错误信息

      const {
        messages,
        email,
        password,
        invite_code
      } = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors) || {};

      if (messages) {
        Message/* default.error */.Z.error(messages);
      }

      if (invite_code) {
        Message/* default.error */.Z.error(invite_code === null || invite_code === void 0 ? void 0 : invite_code[0]);
      }

      form === null || form === void 0 ? void 0 : form.setFields({
        // 存在则展示，不存在不展示
        name: messages ? {
          value: params.name,
          error: {
            message: messages
          }
        } : undefined,
        email: email !== null && email !== void 0 && email[0] ? {
          value: params.email,
          error: {
            message: email === null || email === void 0 ? void 0 : email[0]
          }
        } : undefined,
        password: password !== null && password !== void 0 && password[0] ? {
          value: params.password,
          error: {
            message: password === null || password === void 0 ? void 0 : password[0]
          }
        } : undefined,
        invite_code: invite_code !== null && invite_code !== void 0 && invite_code[0] ? {
          value: params.invite_code,
          error: {
            message: invite_code === null || invite_code === void 0 ? void 0 : invite_code[0]
          }
        } : undefined
      });
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleRegister = async params => {
    setLoading(true);
    const signUpRes = (0,login/* registerApi */.qL)(_objectSpread(_objectSpread({}, params), promotionInfo));
    handleSignUpRes(params, signUpRes);
  };

  function onSubmitClick() {
    form === null || form === void 0 ? void 0 : form.validate().then(values => {
      (0,utils/* addEnhancedConversion */.GH)(values === null || values === void 0 ? void 0 : values.email);
      handleRegister(values);
    }).catch(err => {
      console.log(err);
    });
  }

  const {
    onCaptchaShow
  } = useEmailCaptcha(form, onSubmitClick);
  (0,react.useEffect)(() => {
    form === null || form === void 0 ? void 0 : form.setFieldValue('invite_code', inviteCode);
  }, [inviteCode]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default())["login-form-wrapper"],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default */.Z, {
      form: form,
      className: (index_module_default())["login-form"],
      layout: "vertical",
      initialValues: initialValues,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
        label: t['register.form.email.label'],
        field: "email",
        rules: [{
          required: true,
          validator: utils/* emailFormValidator */.ql,
          message: t['login.form.email.errMsg']
        }],
        initialValue: email || '',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
          type: "email",
          placeholder: t['register.form.email.placeholder'],
          disabled: !!(email !== null && email !== void 0 && email.trim())
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
        label: t['login.form.password.label'],
        field: "password",
        rules: [{
          required: true,
          message: t['login.form.password.errMsg']
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
          type: "password",
          placeholder: t['login.form.password.placeholder']
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
        label: t['register.form.invite.label'],
        field: "invite_code",
        rules: [{
          required: false,
          message: t['login.form.invite.errMsg']
        }] // 邀请码逻辑仍然保留，但是不再展示
        // 2024.05.22 继续展示邀请码
        // style={{ display: 'none' }}
        ,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
          type: "text",
          placeholder: t['register.form.invite.placeholder']
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        size: 16,
        direction: "vertical",
        style: {
          marginTop: 0
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (index_module_default()).emailLogin,
          onClick: () => onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm('phone'),
          children: t['phone_register']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          type: "primary",
          id: "captcha-button",
          long: true,
          onClick: onCaptchaShow,
          loading: loading,
          className: (index_module_default())["login-form-btn"],
          children: t['login.form.register']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["login-form-desc"],
        children: [t['register.tips'], /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://echotik.live/privacy-policy.html",
          target: "_blank",
          rel: "noreferrer",
          className: (index_module_default())["checkbox-protocol"],
          children: t['register.service']
        }), t['register.and'], /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://echotik.live/privacy-policy.html",
          target: "_blank",
          rel: "noreferrer",
          className: (index_module_default())["checkbox-protocol"],
          children: t['register.privacy']
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./src/pages/register/style/register-en.module.less
var register_en_module = __webpack_require__(76782);
var register_en_module_default = /*#__PURE__*/__webpack_require__.n(register_en_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useGoogleAuth.ts
var useGoogleAuth = __webpack_require__(91012);
// EXTERNAL MODULE: ./src/hooks/useGetQuery.ts
var useGetQuery = __webpack_require__(22483);
// EXTERNAL MODULE: ./src/pages/login/phone-form.tsx
var phone_form = __webpack_require__(29056);
;// CONCATENATED MODULE: ./src/pages/register/register-content.tsx





















function RegisterContent() {
  const router = (0,next_router.useRouter)();
  const {
    query
  } = router;
  const {
    step: initStep = '',
    platform = '',
    sessionFlag: initSessionFlag = '',
    f = ''
  } = query || {};
  const email = (0,useGetQuery/* useGetQuery */.X)('email');
  const {
    0: inviteCode,
    1: setInviteCode
  } = (0,react.useState)('');
  const {
    0: sessionFlag,
    1: setSessionFlag
  } = (0,react.useState)(initSessionFlag);
  const {
    0: showWechat,
    1: setShowWechat
  } = (0,react.useState)(false);
  const lang = (0,useLang/* default */.Z)();
  const isEnglish = lang === 'en-US';
  const {
    0: componentType,
    1: setComponentType
  } = (0,react.useState)(isEnglish ? 'email' : 'phone');
  const t = (0,useLocale/* default */.Z)();
  (0,react.useEffect)(() => {
    const curInviteCode = f || localStorage.getItem(constants/* INVITE_CODE_STORAGE */.zX) || '';
    setInviteCode(curInviteCode);
  }, [f]);

  const onBindSuccess = data => {
    var _data$user;

    (0,checkLogin/* setToken */.o4)(data === null || data === void 0 ? void 0 : data.access_token);

    if (!(data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && _data$user.role)) {
      window.location.href = window.location.origin + '/onboarding';
    } else {
      window.location.href = window.location.origin + '/board';
    }
  };

  (0,react.useEffect)(() => {
    if (lang === 'en-US') {
      setComponentType('email');
    }
  }, [lang]);
  const {
    googleAuth,
    isLoading
  } = (0,useGoogleAuth/* default */.Z)({
    onBindSuccess,
    invite_code: inviteCode
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (register_en_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (register_en_module_default())["login-form-title"],
      children: t['register.form.title']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: showWechat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            color: '#403D5A',
            lineHeight: '19px',
            marginBottom: '32px',
            cursor: 'pointer'
          },
          onClick: () => {
            setShowWechat(false);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLeft/* default */.Z, {
            style: {
              marginRight: '8px',
              width: '18px'
            }
          }), t['register.another.way']]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(wechat_login/* default */.Z, {
          type: "register",
          step: "",
          sessionFlag: sessionFlag,
          setSessionFlag: setSessionFlag,
          inviteCode: inviteCode
        }, "register")]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Spin/* default */.Z, {
        loading: isLoading,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          direction: "vertical",
          size: 16,
          style: {
            width: '100%',
            marginTop: '24px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
            icon: /*#__PURE__*/(0,jsx_runtime.jsx)(google/* default */.Z, {}),
            text: t['register.google'],
            onClick: () => {
              try {
                var _window$gtag_report_c, _window;

                (_window$gtag_report_c = (_window = window).gtag_report_conversion) === null || _window$gtag_report_c === void 0 ? void 0 : _window$gtag_report_c.call(_window);
              } catch (error) {
                console.log(error);
              }

              googleAuth();
            }
          }, "google"), /*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
            icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconWechat/* default */.Z, {
              style: {
                color: '#00C800',
                width: '24px',
                height: '24px'
              }
            }),
            text: t['register.wechat'],
            onClick: () => {
              // try {
              //   window.gtag_report_conversion?.()
              // } catch (error) {
              //   console.log(error)
              // }
              setShowWechat(true);
            }
          }, "wechat")]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '16px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              height: '1px',
              flex: 1,
              backgroundColor: '#F0F1F8'
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              margin: '0 8px',
              color: '#403D5A'
            },
            children: t['register.or']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              height: '1px',
              flex: 1,
              backgroundColor: '#F0F1F8'
            }
          })]
        }), componentType === 'email' ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoginForm, {
          email: email,
          sessionFlag: sessionFlag,
          inviteCode: inviteCode,
          step: "fulfill",
          platform: platform,
          onChangeForm: v => {
            setComponentType(v);
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(phone_form/* default */.Z, {
          inviteCode: inviteCode,
          onChangeForm: v => {
            setComponentType(v);
          }
        })]
      })
    })]
  });
}

/* harmony default export */ var register_content = (RegisterContent);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/pages/register/index.tsx












function Register() {
  const t = (0,useLocale/* default */.Z)();
  (0,react.useEffect)(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (index_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).logo,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(logoText/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["logo-text"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).banner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["banner-inner"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(banner/* default */.Z, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).contentHeader,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          size: 24,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/board",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (index_module_default()).headerLink,
              children: t['register.home']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/login",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (index_module_default()).headerLink,
              children: t['register.login']
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSwitch/* default */.Z, {
          theme: "light"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["content-inner"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(register_content, {})
      })]
    })]
  });
}

Register.displayName = 'RegisterPage';
/* harmony default export */ var register = (Register);
// EXTERNAL MODULE: ./src/mobile-pages/login/wechat-login.tsx
var login_wechat_login = __webpack_require__(58089);
// EXTERNAL MODULE: ./src/mobile-pages/register/style/index.module.less
var style_index_module = __webpack_require__(46480);
var style_index_module_default = /*#__PURE__*/__webpack_require__.n(style_index_module);
// EXTERNAL MODULE: ./src/mobile-components/MobileLangSwitch/index.tsx
var MobileLangSwitch = __webpack_require__(30567);
// EXTERNAL MODULE: ./src/mobile-pages/login/phone-login.tsx
var phone_login = __webpack_require__(50011);
;// CONCATENATED MODULE: ./src/mobile-pages/register/index.tsx


function register_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function register_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? register_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : register_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























const register_initialValues = {
  email: '',
  password: '',
  invite_code: ''
};

const register_Register = () => {
  const router = (0,next_router.useRouter)();
  const {
    query
  } = router;
  const [form] = Form/* default.useForm */.Z.useForm();
  const {
    email = '',
    sessionFlag: initSessionFlag = '',
    f = ''
  } = query || {};
  const {
    qhclickid
  } = (0,useBdVid/* getBdVid */.Wu)();
  const promotionInfo = (0,useBdVid/* getPromotionInfo */.yG)();
  const {
    0: inviteCode,
    1: setInviteCode
  } = (0,react.useState)('');
  const {
    0: sessionFlag,
    1: setSessionFlag
  } = (0,react.useState)(initSessionFlag);
  const {
    0: showWechat,
    1: setShowWechat
  } = (0,react.useState)(false);
  const {
    0: loading,
    1: setLoading
  } = (0,react.useState)(false);
  const t = (0,useLocale/* default */.Z)();
  const {
    afterRegisterSuccess
  } = (0,useAfterOnboarding/* default */.Z)({
    rememberPassword: false
  });
  const {
    0: componentType,
    1: setComponentType
  } = (0,react.useState)('phone');
  const lang = (0,useLang/* default */.Z)();

  const handleSignUpRes = (params, signUpRes) => {
    signUpRes.then(res => {
      const {
        code
      } = (res === null || res === void 0 ? void 0 : res.data) || {};

      if (code === 0) {
        Message/* default.success */.Z.success(t['register.form.result.successMsg']); // 增加百度统计，注册转化成功

        (0,utils/* baiduRegisterEvent */.Rk)(); // qhTrackRegister({
        //   qhclickid,
        //   id: res?.data?.data?.user?.user_id
        // })

        (0,gtagEvent/* gtagRegisterEvent */.IQ)();
        afterRegisterSuccess(params, res === null || res === void 0 ? void 0 : res.data);
      } else {
        console.log(code);
      }
    }).catch(err => {
      var _err$response, _err$response$data;

      console.log('err', err === null || err === void 0 ? void 0 : err.response); // 设置错误信息

      const {
        messages,
        email,
        password,
        invite_code
      } = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors) || {};

      if (messages) {
        Message/* default.error */.Z.error(messages);
      }

      if (invite_code) {
        Message/* default.error */.Z.error(invite_code === null || invite_code === void 0 ? void 0 : invite_code[0]);
      }

      form === null || form === void 0 ? void 0 : form.setFields({
        // 存在则展示，不存在不展示
        name: messages ? {
          value: params.name,
          error: {
            message: messages
          }
        } : undefined,
        email: email !== null && email !== void 0 && email[0] ? {
          value: params.email,
          error: {
            message: email === null || email === void 0 ? void 0 : email[0]
          }
        } : undefined,
        password: password !== null && password !== void 0 && password[0] ? {
          value: params.password,
          error: {
            message: password === null || password === void 0 ? void 0 : password[0]
          }
        } : undefined,
        invite_code: invite_code !== null && invite_code !== void 0 && invite_code[0] ? {
          value: params.invite_code,
          error: {
            message: invite_code === null || invite_code === void 0 ? void 0 : invite_code[0]
          }
        } : undefined
      });
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleRegister = async params => {
    // 不再校验验证码
    // if (!isEffective) {
    //   Message.error(t['register.form.no.invite.code'])
    //   return
    // }
    setLoading(true);
    const signUpRes = (0,login/* registerApi */.qL)(register_objectSpread(register_objectSpread({}, params), promotionInfo));
    handleSignUpRes(params, signUpRes);
  };

  function onSubmitClick() {
    form === null || form === void 0 ? void 0 : form.validate().then(values => {
      (0,utils/* addEnhancedConversion */.GH)(values === null || values === void 0 ? void 0 : values.email);
      handleRegister(values);
    });
  }

  const {
    onCaptchaShow
  } = useEmailCaptcha(form, onSubmitClick);
  (0,react.useEffect)(() => {
    form === null || form === void 0 ? void 0 : form.setFieldValue(constants/* INVITE_CODE_STORAGE */.zX, inviteCode);
  }, [inviteCode]);
  (0,react.useEffect)(() => {
    const curInviteCode = f || localStorage.getItem('invite_code') || '';
    setInviteCode(curInviteCode);
  }, [f]);

  const onBindSuccess = data => {
    var _data$user;

    (0,checkLogin/* setToken */.o4)(data === null || data === void 0 ? void 0 : data.access_token);

    if (!(data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && _data$user.role)) {
      window.location.href = window.location.origin + '/onboarding';
    } else {
      window.location.href = window.location.origin + '/board';
    }
  };

  const {
    googleAuth,
    isLoading
  } = (0,useGoogleAuth/* default */.Z)({
    onBindSuccess,
    invite_code: inviteCode
  });
  (0,react.useEffect)(() => {
    if (lang === 'en-US') {
      setComponentType('email');
    }
  }, [lang]);

  if (showWechat) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(login_wechat_login/* default */.Z, {
      type: "login",
      setShowWechat: setShowWechat,
      step: "",
      sessionFlag: sessionFlag,
      setSessionFlag: setSessionFlag,
      inviteCode: inviteCode
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (style_index_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (style_index_module_default()).lang,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/board",
        children: t['menu.platform.board']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileLangSwitch/* default */.Z, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (style_index_module_default()).title,
      children: t['register.form.title']
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Spin/* default */.Z, {
      loading: isLoading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        direction: "vertical",
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(google/* default */.Z, {}),
          text: t['register.google'],
          onClick: () => {
            googleAuth();
          }
        }, "google"), /*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconWechat/* default */.Z, {
            style: {
              color: '#00C800',
              width: '24px',
              height: '24px'
            }
          }),
          text: t['register.wechat'],
          onClick: () => {
            setShowWechat(true);
          }
        }, "wechat")]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (style_index_module_default())["or-wrap"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (style_index_module_default())["or-line"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (style_index_module_default()).or,
          children: t['register.or']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (style_index_module_default())["or-line"]
        })]
      }), componentType === 'email' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default */.Z, {
          form: form,
          layout: "vertical",
          initialValues: register_initialValues,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
            label: t['register.form.email.placeholder'],
            field: "email",
            rules: [{
              required: true,
              validator: utils/* emailFormValidator */.ql,
              message: t['login.form.email.errMsg']
            }],
            initialValue: email || '',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
              type: "email",
              placeholder: t['register.form.email.placeholder'],
              disabled: !!(email !== null && email !== void 0 && email.trim())
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
            label: t['login.form.password.label'],
            field: "password",
            rules: [{
              required: true,
              message: t['login.form.password.errMsg']
            }],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
              type: "password",
              placeholder: t['login.form.password.placeholder']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
            label: t['register.form.invite.label'],
            field: "invite_code",
            rules: [{
              required: false,
              message: t['login.form.invite.errMsg']
            }] // 邀请码逻辑仍然保留，但是不再展示，
            // 2024.05.22 继续展示邀请码
            // style={{ display: 'none' }}
            ,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
              type: "text",
              placeholder: t['register.form.invite.placeholder']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (style_index_module_default()).phone_register,
            onClick: () => {
              setComponentType('phone');
            },
            children: t['phone_register']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "primary",
            id: "captcha-button",
            long: true,
            onClick: onCaptchaShow,
            loading: loading,
            className: (style_index_module_default()).btn,
            children: t['login.form.register']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (style_index_module_default())["no-account"],
          children: [t['login.have.account'], /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (style_index_module_default())["no-account-text"],
            onClick: () => {
              router.push('/login');
            },
            children: t['login.form.title']
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(phone_login/* default */.Z, {
        onChangeForm: v => {
          setComponentType(v);
        }
      })]
    })]
  });
};

/* harmony default export */ var mobile_pages_register = (register_Register);
// EXTERNAL MODULE: ./src/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(97588);
;// CONCATENATED MODULE: ./pages/register/index.tsx





const pages_register_Register = () => {
  return (0,useIsMobile/* default */.Z)() ? /*#__PURE__*/(0,jsx_runtime.jsx)(mobile_pages_register, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(register, {});
};

/* harmony default export */ var pages_register = (pages_register_Register);

/***/ }),

/***/ 22483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useGetQuery; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

const useGetQuery = name => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  const {
    asPath
  } = router;
  const query = asPath.split('?')[1];
  if (!query) return '';
  const queryObj = query.split('&').reduce((prev, curr) => {
    const [key, value] = curr.split('=');
    prev.set(key, value);
    return prev;
  }, new Map());
  return queryObj.get(name) ?? '';
};

/***/ }),

/***/ 76276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(98160);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__UISG4","title":"index_title__aXIeZ","btn":"index_btn__MzOL6","login-form-title":"index_login-form-title__weJOJ","login-form-sub-title":"index_login-form-sub-title__suU86","no-account":"index_no-account__A33Ka","no-account-text":"index_no-account-text__seQnc","or-wrap":"index_or-wrap__NFB8u","or-line":"index_or-line__GayK9","or":"index_or__Ctpqk","other":"index_other__8xwvL","icon-wrap":"index_icon-wrap__AFMtw","lang":"index_lang__Nh603","phone_register":"index_phone_register__HDyeS"};

/***/ }),

/***/ 50859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__77HmQ","banner":"index_banner__i5p5a","content":"index_content___fMhf","footer":"index_footer__WwF1p","checkbox-protocol":"index_checkbox-protocol__a_iSR","contentHeader":"index_contentHeader__6rZgt","headerLink":"index_headerLink__zsJDq","logo":"index_logo__EjFbN","logo-text":"index_logo-text__MUuii","banner-inner":"index_banner-inner__mushx","carousel":"index_carousel__612yH","carousel-item":"index_carousel-item__iSBiV","carousel-title":"index_carousel-title__Fj2Y2","carousel-sub-title":"index_carousel-sub-title__sgtTO","carousel-image":"index_carousel-image__T4NQj","login-form-wrapper":"index_login-form-wrapper__9FOht","login-form-title":"index_login-form-title__Ov5Ia","login-form-sub-title":"index_login-form-sub-title__jw_jO","login-form-error-msg":"index_login-form-error-msg__KzZ11","login-form-password-actions":"index_login-form-password-actions__pzgUU","login-form-btn":"index_login-form-btn__ihcGu","login-form-desc":"index_login-form-desc__9MhyG","login-form-register-btn":"index_login-form-register-btn__YElbn","emailLogin":"index_emailLogin__h4qIX"};

/***/ }),

/***/ 76782:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"login-form-title":"register-en_login-form-title__pTxeu","login-form-sub-title":"register-en_login-form-sub-title__nfsXw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9458,2403,1077,5976,1885,2031,9089,9928,3767,3220,455,4050,8986,5695,3279,4136,9669,587,6205,3242,7931,1926,4452,5417,6351,1120,5871,236,6611,3097,1954,4347,7634,9509,5287,9,336,9843,8594,1258,5280,9778,7971,1738,9161,6158,4071,3066], function() { return __webpack_exec__(76276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);